import { render, staticRenderFns } from "./distributeBoard.vue?vue&type=template&id=de67011e&scoped=true&"
import script from "./distributeBoard.ts?vue&type=script&lang=js&"
export * from "./distributeBoard.ts?vue&type=script&lang=js&"
import style0 from "./distributeBoard.vue?vue&type=style&index=0&id=de67011e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de67011e",
  null
  
)

export default component.exports